// extracted by mini-css-extract-plugin
export default {"content":"my-order_content__ECaLs","header":"my-order_header__nmgJz","title":"my-order_title__BIO53"};